export default __webpack_public_path__ + "static/media/ion.d076a2d0.svg";